import api from "../../services/api";

// Perfil ENXUTO do Assistente do Coletor — reusa o MESMO CopilotPanel (loop
// agêntico, ask_user, prompt caching), mas com um system pequeno e só 3
// ferramentas (sem o catálogo de construção de fluxo). Cada volta é barata.

export const COLLECTOR_TOOLS = [
  {
    name: "introspect_schema",
    description:
      "Lê a ESTRUTURA do banco (tabelas, colunas, tipos e chaves estrangeiras) de uma conexão MySQL. Use PRIMEIRO, para descobrir onde estão os dados que o usuário pediu.",
    input_schema: {
      type: "object",
      properties: { connectorId: { type: "number", description: "id da conexão MySQL (veja no contexto)." } },
      required: ["connectorId"],
    },
  },
  {
    name: "run_sample_query",
    description:
      "Roda um SELECT read-only e devolve algumas linhas (LIMIT automático). Use para CONFIRMAR com dados reais qual é a tabela/campo certo antes de criar o coletor (ex.: mostrar a última linha e perguntar ao usuário se confere). Só SELECT.",
    input_schema: {
      type: "object",
      properties: {
        connectorId: { type: "number" },
        query: { type: "string", description: "um SELECT (sem ponto e vírgula)." },
        params: { type: "array", items: {}, description: "valores para os ? da query (opcional)." },
      },
      required: ["connectorId", "query"],
    },
  },
  {
    name: "create_connector",
    description:
      "Abre um modal para o USUÁRIO configurar (e criar) um conector AQUI MESMO — use quando NÃO houver uma conexão MySQL e você precisar de uma. NÃO mande o usuário para outra tela. As credenciais são digitadas por ele na UI e nunca passam por você. Retorna { connector_id } (use no introspect_schema/create_collector).",
    input_schema: {
      type: "object",
      properties: { type: { type: "string", description: "tipo do conector — aqui use 'mysql'." } },
      required: ["type"],
    },
  },
  {
    name: "save_schema_note",
    description:
      "Grava uma DESCOBERTA durável sobre o banco (o que você confirmou e vai ajudar nas próximas vezes): qual tabela é o quê, qual campo é o cursor / a data de criação, um join, o significado de um status. Uma nota curta por chamada. NUNCA salve dados de linhas.",
    input_schema: {
      type: "object",
      properties: {
        connectorId: { type: "number" },
        note: { type: "string", description: "a descoberta, curta (ex.: 'faturas = tabela de faturas; cursor = id; data de geração = gerada_em')." },
      },
      required: ["connectorId", "note"],
    },
  },
  {
    name: "create_collector",
    description:
      "Cria OU ATUALIZA o Coletor de dados com a query final. Só chame quando estiver SEGURO (já confirmou tabela/campos e validou com run_sample_query). Contrato da query: um SELECT (JOINs ok), NOMES DE COLUNA ÚNICOS (dê alias quando repetir), e o cursorField precisa estar no SELECT e ser crescente para linhas novas (id PK da tabela principal, ou uma data/hora de criação). Para ATUALIZAR um coletor que já existe (um que você criou nesta conversa OU um da lista de coletores existentes), passe o collectorId dele — assim ele é atualizado NO LUGAR, sem criar duplicado.",
    input_schema: {
      type: "object",
      properties: {
        name: { type: "string", description: "nome curto do coletor (ex.: 'Clientes novos')." },
        connectorId: { type: "number" },
        query: { type: "string", description: "o SELECT final (sem ponto e vírgula)." },
        cursorField: { type: "string", description: "coluna sequencial (cursor), presente no SELECT (ex.: id)." },
        pollEvery: { type: "string", enum: ["5m", "15m", "30m", "1h", "6h", "12h", "24h"], description: "frequência (padrão 15m)." },
        collectorId: { type: "number", description: "OPCIONAL. id de um coletor existente para ATUALIZAR no lugar (em vez de criar outro)." },
      },
      required: ["name", "connectorId", "query", "cursorField"],
    },
  },
  {
    name: "test_collector",
    description:
      "Roda uma rodada do coletor AGORA (traz os registros e dispara o consumidor por registro) e devolve o resumo (quantos registros/disparos). Use para o usuário ver funcionando antes/depois de publicar.",
    input_schema: {
      type: "object",
      properties: { collectorId: { type: "number", description: "id do coletor (retornado por create_collector)." } },
      required: ["collectorId"],
    },
  },
  {
    name: "publish_collector",
    description:
      "Publica o coletor — a partir daí ele roda SOZINHO no intervalo do Polling. Use quando o usuário confirmar que está bom.",
    input_schema: {
      type: "object",
      properties: { collectorId: { type: "number", description: "id do coletor (retornado por create_collector)." } },
      required: ["collectorId"],
    },
  },
  {
    name: "reset_collector",
    description:
      "Zera o CURSOR do coletor (o estado de 'até onde já li'). A próxima rodada vira a 1ª de novo e REPROCESSA os registros mais recentes — o que REDISPARA as automações ligadas (pode reenviar/religar). NÃO muda o desenho do fluxo. Use quando o usuário pedir pra 'recomeçar do zero'/'reprocessar'/'resetar o coletor'. AVISE o efeito e confirme (ask_user) antes de chamar, principalmente se o consumidor liga/envia.",
    input_schema: {
      type: "object",
      properties: { collectorId: { type: "number", description: "id do coletor a resetar." } },
      required: ["collectorId"],
    },
  },
  {
    name: "ask_user",
    description:
      "Faça UMA pergunta ao usuário quando precisar de algo que não dá para deduzir (ex.: qual conexão usar, confirmar a tabela de faturas). UMA pergunta por chamada. Prefira opções quando houver alternativas claras. O resultado da tool É a resposta do usuário.",
    input_schema: {
      type: "object",
      properties: {
        question: { type: "string", description: "A pergunta, curta e direta (1 frase)." },
        input_type: { type: "string", enum: ["text", "choice", "multi"], description: "text = livre; choice = uma opção; multi = várias." },
        options: { type: "array", items: { type: "string" }, description: "Opções para choice/multi (2 a 6). Omita em 'text'." },
        placeholder: { type: "string", description: "Dica do campo, só para 'text' (opcional)." },
      },
      required: ["question", "input_type"],
    },
  },
];

export const buildCollectorSystem = ctx => {
  const conns =
    (ctx.connectors || [])
      .filter(c => !c.type || c.type === "mysql") // ctx do copiloto de fluxo traz todos os tipos
      .map(c => `${c.id}:${c.name}`)
      .join(", ") || "(nenhuma)";
  // IP para o texto que o leigo manda pro TI (varia por plano — vem do contexto)
  const eg = (ctx && ctx.mysqlEgress) || {};
  const ipLine = eg.fixed && eg.ip
    ? `Segurança/firewall: as consultas saem de um serviço externo, sempre somente-leitura. Se o banco só aceita IPs liberados, libere o IP fixo: ${eg.ip}.`
    : "Segurança/firewall: as consultas saem de um serviço externo, sempre somente-leitura, por IPs dinâmicos — então o banco precisa ficar acessível pela internet.";
  return [
    "Você é o Assistente do Coletor de dados de uma plataforma no-code, falando com um usuário LEIGO em português simples.",
    "A partir de uma frase (ex.: 'envie email pro cliente quando gerar fatura'), monte a QUERY de um COLETOR que traz os registros NOVOS de um banco MySQL.",
    "",
    `Conexões MySQL disponíveis (id:nome): ${conns}`,
    "Se houver só uma conexão, use-a sem perguntar. Se houver várias e não der pra deduzir, pergunte (ask_user).",
    "",
    `Coletores JÁ EXISTENTES neste projeto (id:nome): ${((ctx && ctx.collectors) || []).map(c => `${c.id}:${c.name}`).join(", ") || "(nenhum)"}`,
    "Se o pedido é ajustar/refinar um destes (mesmo objetivo), NÃO crie outro: chame create_collector passando o collectorId dele para ATUALIZAR no lugar.",
    "",
    "SE NÃO HOUVER NENHUMA CONEXÃO MYSQL: NÃO abra o modal direto (o usuário pode ser LEIGO e não ter os dados). PERGUNTE primeiro (ask_user):",
    "  'Você tem em mãos os dados de conexão do banco (endereço, usuário e senha)? Ou prefere que eu prepare um texto pra você mandar pro seu pessoal de TI?'",
    "- Se ELE TEM os dados → chame create_connector({type:'mysql'}) pra ele preencher AQUI mesmo (não mande pra outra tela).",
    "- Se ELE NÃO TEM → entregue este texto pronto (copiável) pra ele encaminhar ao TI, e explique que, quando tiver os dados, é só voltar aqui:",
    "  ---",
    "  Assunto: Preciso dos dados de acesso ao nosso banco de dados (somente leitura)",
    "  Oi! Estou montando uma automação que precisa LER nosso banco para detectar registros novos (ex.: clientes recém-cadastrados) e disparar ações. É somente leitura — nada será alterado.",
    "  Pode me passar os dados de conexão do banco MySQL?",
    "  - Endereço (host): (ex.: db.empresa.com ou o IP)",
    "  - Porta: (padrão 3306)",
    "  - Nome do banco (database):",
    "  - Usuário e senha: (de preferência um usuário SÓ DE LEITURA, criado pra isso)",
    `  ${ipLine}`,
    "  Qualquer dúvida técnica, me chama. Obrigado!",
    "  ---",
    "",
    "FLUXO:",
    "1. introspect_schema(connectorId) — descubra tabelas/colunas/FKs. A resposta traz TAMBÉM as NOTAS já",
    "   descobertas sobre este banco (memória): USE-AS — não repergunte o que já está lá.",
    "2. Raciocine qual tabela e campos atendem o pedido. Quando tiver DÚVIDA, NÃO chute: use run_sample_query pra mostrar dados reais e ask_user pra CONFIRMAR (ex.: 'a última fatura gerada é o id 1234?', 'a data de geração é o campo criado_em?').",
    "3. Valide a query final com run_sample_query.",
    "4. create_collector(...) — só quando estiver seguro. Antes, explique em 1 frase o que o coletor vai trazer.",
    "   UM COLETOR SÓ — NUNCA DUPLIQUE. Depois que create_collector devolver um collectorId, esse é O coletor:",
    "   reutilize esse mesmo id em test_collector/publish_collector e ao ligar automações.",
    "   Para AJUSTAR o SQL/campos depois (mesmo após publicar), chame create_collector DE NOVO passando o",
    "   collectorId dele — ele é atualizado NO LUGAR (não cria outro). Só crie sem collectorId quando for um",
    "   coletor genuinamente NOVO. Se já existe um coletor para esse mesmo objetivo (veja a lista de coletores",
    "   existentes), ATUALIZE-o (passe o collectorId) em vez de criar um parecido.",
    "",
    "CONTRATO da query:",
    "- UM único SELECT read-only (JOINs permitidos). Sem ponto e vírgula.",
    "- NOMES DE COLUNA ÚNICOS no resultado (alias quando repetir: c.nome AS cliente_nome).",
    "- cursorField = coluna PRESENTE no SELECT e crescente para linhas novas (id PK da tabela principal; senão uma data/hora de CRIAÇÃO). Nunca um campo que é atualizado.",
    "- Traga os campos que o usuário vai usar depois (ex.: se for mandar email pro cliente, inclua o email do cliente via JOIN).",
    "",
    "MEMÓRIA DO BANCO: sempre que CONFIRMAR algo novo e durável (qual tabela é o quê, qual é o cursor / a data",
    "de criação, um join, o significado de um status), salve com save_schema_note — assim das próximas vezes você",
    "pergunta menos e vai mais rápido. Não salve dados de linhas, só o entendimento do banco.",
    "",
    "DEPOIS de create_collector (que devolve o id do coletor): você mesmo pode TESTAR e PUBLICAR por aqui —",
    "não mande o usuário fazer isso em outra tela. Ofereça: test_collector(id) roda uma rodada agora e mostra",
    "quantos registros vieram/disparos; publish_collector(id) faz ele rodar sozinho no intervalo. Sugira testar",
    "antes de publicar. Explique o resultado do teste em português simples.",
    "",
    "RESETAR: se o usuário quiser recomeçar a leitura do zero/reprocessar, chame",
    "reset_collector(collectorId) — zera o cursor; a próxima rodada relê do início e",
    "REDISPARA as automações ligadas. Avise o efeito e confirme (ask_user) antes.",
  ].join("\n");
};

export const collectorProfile = {
  title: "Assistente do Coletor",
  ctxChip: "coletor de dados",
  emptyTitle: "Descreva o que você quer coletar",
  emptyDesc: "Eu leio seu banco e monto o coletor pra você. Ex.: 'clientes novos', 'faturas geradas com o email do cliente'.",
  examples: ["Coletar os clientes novos", "Faturas novas com o email do cliente", "Pedidos criados a partir de agora"],
  quickReplies: [],
  placeholder: "Descreva o que coletar…",
  initialExtra: {},
  loadContext: async projectId => {
    const safe = async p => p.then(r => r.data).catch(() => null);
    const [conns, eg, apps] = await Promise.all([
      safe(api.get("/connectors")),
      safe(api.get("/connectors/mysql-egress")),
      safe(api.get("/applications", { params: projectId ? { projectId } : {} })),
    ]);
    const arr = (d, k) => (Array.isArray(d) ? d : (d && d[k]) || []);
    return {
      connectors: arr(conns, "connectors").filter(c => c.type === "mysql").map(c => ({ id: c.id, name: c.name })).slice(0, 30),
      collectors: arr(apps, "applications").filter(a => a.triggerType === "collector").map(a => ({ id: a.id, name: a.name })).slice(0, 30),
      mysqlEgress: eg || {},
    };
  },
  buildSystem: ctx => buildCollectorSystem(ctx),
  buildTools: () => COLLECTOR_TOOLS,
};

// runTool do assistente: as 3 ferramentas chamam os endpoints do backend. ask_user
// é tratado pelo próprio loop do CopilotPanel (não passa por aqui). Recebe o
// projectId e um callback onCreated(navega/atualiza) via closure.
export const makeCollectorRunTool = (projectId, onCreated) => async (name, input) => {
  try {
    if (name === "introspect_schema") {
      const { data } = await api.post("/connectors/introspect-schema", { connectorId: input.connectorId });
      return data;
    }
    if (name === "run_sample_query") {
      const { data } = await api.post("/connectors/sample-query", { connectorId: input.connectorId, query: input.query, params: input.params || [] });
      return data;
    }
    if (name === "save_schema_note") {
      const { data } = await api.post("/connectors/save-schema-note", { connectorId: input.connectorId, note: input.note });
      return data;
    }
    if (name === "create_collector") {
      const { data } = await api.post("/applications/materialize-collector", {
        name: input.name,
        connectorId: input.connectorId,
        query: input.query,
        cursorField: input.cursorField,
        pollEvery: input.pollEvery,
        collectorId: input.collectorId,
        projectId,
      });
      if (data && data.ok && onCreated) onCreated(data);
      return data;
    }
    if (name === "test_collector") {
      const { data } = await api.post(`/applications/${input.collectorId}/collector-run-now`, {});
      return data;
    }
    if (name === "reset_collector") {
      const { data } = await api.post(`/applications/${input.collectorId}/collector-reset`, {});
      return data;
    }
    if (name === "publish_collector") {
      const { data } = await api.post(`/applications/${input.collectorId}/publish`, {});
      const v = data && data.application && data.application.publishedVersion;
      return { ok: true, publishedVersion: v || (data && data.version && data.version.version) || null };
    }
    return { error: `ferramenta desconhecida: ${name}` };
  } catch (e) {
    return { error: (e.response && e.response.data && e.response.data.error) || e.message };
  }
};
